import { useMutation, useQuery } from '@tanstack/react-query';
import { getCmsLoyaltySliderContentFn, getLoyaltyEligibilityFn, getLoyaltyInfoFn, getLoyaltyProductsFn, registerLoyaltyFn } from '../../transactions/loyalty/loyalty';
import { PAGES } from '../../config/constants';
import usePersonStore from '../../store/personStore';
import useLoyaltyStore from '../../store/loyaltyStore';
import { validateResponse } from '../../pages/service/serviceUtils';

export const useLoyaltyEligibility = ({enabled=false}) => {
  return useQuery({
    queryKey: ['loyaltyEligibility'],
    queryFn: () => getLoyaltyEligibilityFn(),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: enabled,
    onSuccess: (response) => {
      const { setIsLoyaltyEligible, setPageAccess, pageAccess } =
        usePersonStore.getState();
      const isEligible = !!response?.isEligible;
      setIsLoyaltyEligible(isEligible);
      // setPageAccess(
      //   isEligible
      //     ? [...new Set([...(pageAccess || []), PAGES.LOYALTY])]
      //     : (pageAccess || []).filter((item) => item !== PAGES.LOYALTY)
      // );
    },
  });
};

export const useLoyaltyInfo = ({enabled=false}) => {
  return useQuery({
    queryKey: ['loyaltyInfo'],
    queryFn: () => getLoyaltyInfoFn(),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: enabled,
    onSuccess: (response) => {
      const { setLoyaltyInfo } = usePersonStore.getState();
      const { setIsLoyaltyEnrolled } = usePersonStore.getState();
      setLoyaltyInfo(response);
      if(!!response && response?.exceptions?.[0] !== 'User is not registered.') {
          setIsLoyaltyEnrolled(true)
        } else {
          setIsLoyaltyEnrolled(false)
        }
    },
  });
};

export const useLoyaltyProducts = ({enabled=false}) => {
  return useQuery({
    queryKey: ['loyaltyProducts'],
    queryFn: () => getLoyaltyProductsFn(),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: enabled,
    onSuccess: (response) => {
      const { setLoyaltyProducts, setCanRedeemPickUp } = useLoyaltyStore.getState()
      const { loyaltyInfo } = usePersonStore.getState()
      const success = validateResponse(response)
      if(success) {
        setLoyaltyProducts(response)
        // console.log('calculating redemption')
        // console.log(response?.filter((product) => product?.name === "Pick Up Booking")?.[0]?.redemptionPoints)
        // console.log(loyaltyInfo?.awardPoints)
        // console.log(response?.filter((product) => product?.name === "Pick Up Booking")?.[0]?.redemptionPoints < loyaltyInfo?.awardPoints)
        setCanRedeemPickUp(!!loyaltyInfo && response?.filter((product) => product?.name === "Pick-Up & Delivery")?.[0]?.redemptionPoints < loyaltyInfo?.awardPoints)
      }
    },
  });
};

//mock response


// export const useLoyaltyInfo = ({enabled=false}) => {
//   const ENABLE_LOYALTY_MOCK = true; 

//   const mockLoyaltyTransactions = [
//     {
//       loyaltyTransactionNumber: "LTN-ID-0207",
//       loyaltyTransactionType: "Accrual",
//       transactionDate: null,
//       processedDate: "2025-10-31T08:48:44Z",
//       awardPoints: 10,
//       tierPoints: 0,
//       loyaltyProduct: "Admin Award Product",
//       comments: null,
//     },
//     {
//       loyaltyTransactionNumber: "LTN-ID-0208",
//       loyaltyTransactionType: "Redemption",
//       transactionDate: null,
//       processedDate: "2025-10-31T08:50:00Z",
//       awardPoints: 0,
//       tierPoints: 5,
//       loyaltyProduct: "Admin Tier Product",
//       comments: null,
//     },
//     {
//       loyaltyTransactionNumber: "LTN-ID-0277",
//       loyaltyTransactionType: "Redemption",
//       transactionDate: "2025-06-20T10:12:00Z",
//       processedDate: "2026-03-09T11:00:23Z",
//       awardPoints: 200,
//       tierPoints: 0,
//       loyaltyProduct: "Pick Up Booking",
//       comments: null,
//     },
//   ];

//   const mockTxnAccrualItems = [
//     {
//       createdOn: "2025-10-31T08:48:44Z",
//       pointsQuantity: 10,
//       pointType: "Award Points",
//       expirationDate: "2030-05-14T00:00:00Z",
//     },
//     {
//       createdOn: "2026-03-20T08:48:44Z",
//       pointsQuantity: 5,
//       pointType: "Tier Points",
//       expirationDate: "2030-05-14T00:00:00Z",
//     },
//   ];

//   return useQuery({
//     queryKey: ["loyaltyInfo"],
//     queryFn: () => getLoyaltyInfoFn(),
//     staleTime: Infinity,
//     cacheTime: Infinity,
//     enabled: enabled,
//     onSuccess: (response) => {
//       const { setLoyaltyInfo, setIsLoyaltyEnrolled } = usePersonStore.getState();
//       // ✅ Inject mocks only when enabled AND arrays are empty/missing
//       const patched = ENABLE_LOYALTY_MOCK
//         ? {
//             ...response,
//             listOfLoyaltyTransactions:
//               Array.isArray(response?.listOfLoyaltyTransactions) &&
//               response.listOfLoyaltyTransactions.length > 0
//                 ? response.listOfLoyaltyTransactions
//                 : mockLoyaltyTransactions,
//             listOfTXNAccrualItems:
//               Array.isArray(response?.listOfTXNAccrualItems) &&
//               response.listOfTXNAccrualItems.length > 0
//                 ? response.listOfTXNAccrualItems
//                 : mockTxnAccrualItems,
//           }
//         : response;

//       setLoyaltyInfo(patched);

//       if (
//         !!patched &&
//         // !patched?.success &&
//         patched?.message !== "User is not registered."
//       ) {
//         setIsLoyaltyEnrolled(true);
//       }
//     },
//   });
// };


export const useRegisterLoyalty = () => {
  return useMutation({
    mutationFn: (payload) => registerLoyaltyFn(payload),
    onSuccess: async (data) => {
      // ToDo: make a toast
    },
  });
};

export const useFetchLoyaltyDrupalContent = ({role, params}) => {
  return useQuery({
    queryKey: ['loyalty-drupal-content'],
    queryFn: () => getCmsLoyaltySliderContentFn({role, params}),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });
};